import useGetQMSLeSchoolGrades from './useGetQMSLeSchoolGrades';

export default useGetQMSLeSchoolGrades;
